// extracted by mini-css-extract-plugin
export default {"modal":"bmXvzLfttr2mKfltTbNr","btns":"K_q2SipNBUixesHtAJBb"};